import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { useIdentity } from '@whizz/react-identity';
import { LiveChat as LiveChatAcquire } from '@whizz/react-acquire';

const LiveChat = (): JSX.Element => {
  const { locale } = useI18n();
  const { me } = useIdentity();
  // TODO: Types not matching with `api-model`
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const LiveChatConfigured = () => <LiveChatAcquire locale={locale} me={me} direction='rtl' />;
  return <LiveChatConfigured />;
};

LiveChat.displayName = 'LiveChat';

export default LiveChat;
